export enum WebSocketEventName {
  ERROR = "error",
  CONNECT = "connect",
  VIDEO_EXPORT_DONE = "video_export_done",
  EPISODE_GENERATED = "episode_generated",
  EPISODE_DURATION_UPDATED = "episode_duration_updated",
  EPISODE_PROCESSING_FAILED = "episode_processing_failed",
  EPISODE_INSIGHTS_GENERATED = "episode_insights_generated",
  AUDIOGRAM_EXPORT_DONE = "audiogram_export_done",
  SHORT_VIDEO_GENERATED = "short_video_generated",
  SHORT_VIDEO_GENERATION_FAILED = "short_video_generation_failed",
}
